import {
  Box,
  Button,
  createStyles,
  Switch,
  Select,
  Tooltip,
  Center,
  Checkbox,
  Table,
  TextInput,
  Skeleton,
  Menu,
} from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import ClaimToolbar from "../../../components/ClaimBilling/ClaimToolbar";
import moment from "moment-timezone";
import {
  LuSettings2,
  LuBuilding2,
  LuUsers,
  LuFileText,
  LuCreditCard,
  LuPlus,
  LuTrash2,
  LuArrowLeft,
  LuRefreshCw,
  LuAlertTriangle,
  LuMoreVertical,
  LuEye,
  LuDownload,
  LuShieldCheck,
  LuUserCog,
} from "react-icons/lu";
import { BiChevronDown } from "react-icons/bi";
import { IconTrash, IconBulb, IconSearch } from "@tabler/icons-react";

import AddProvider from "../../../components/ClaimBilling/AddProvider";
import AddClient from "../../../components/ClaimBilling/AddClient";
import AddPayer from "../../../components/ClaimBilling/AddPayer";
import EditPayer from "../../../components/ClaimBilling/AddPayer";
import EditProvider from "../../../components/ClaimBilling/AddProvider";
import EditClient from "../../../components/ClaimBilling/AddClient";
import ProviderEnrollment from "../../../components/ClaimBilling/ProviderEnrollment";
import BillingSearchAll from "../../../components/Document/BilllingSearchAll";
import TableLoader from "../../../components/TableLoader";
import RecordNotFound from "../../../components/RecordNotFound";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import { PaymentTab } from "../BillingClaimForm/PaymentTab";
import VerifyEligibilityModal from "../../../components/ClaimBilling/VerifyEligibilityModal";
import ReceiptViewModal from "../../../components/ClaimBilling/ReceiptViewModal";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { decrypt } from "../../../utils/index";
import useDebounce from "../../../utils/useDebounce";
import {
  getBillingProvider,
  removeProvider,
} from "../../../services/billingprovider";
import {
  createpayer,
  getpayer,
  getpayerlist,
  removepayer,
} from "../../../services/payer";
import {
  getAllBillingPayments,
  getBillingCard,
  getAllFacilitiesModal,
  getAllBillingModal,
} from "../../../services";
import { getAllPatients, editPatient } from "../../../services/patient";
import { getServicecode, getProccode } from "../../../services/servicecode";
import { updateProfile } from "../../../services/profile";

const SIDEBAR_ITEMS = [
  {
    section: "Configuration",
    items: [
      { key: "preferences", label: "Claim Preferences", icon: LuSettings2 },
      { key: "provider", label: "Billing Provider", icon: LuBuilding2 },
      { key: "payer", label: "Payers", icon: LuFileText },
      { key: "client", label: "Clients", icon: LuUsers },
    ],
  },
  {
    section: "Account",
    items: [{ key: "receipts", label: "Receipts", icon: LuFileText }],
  },
  // {
  //   section: "Payments",
  //   items: [{ key: "payment", label: "Payments", icon: LuCreditCard }],
  // },
];

const useStyles = createStyles(() => ({
  pageWrapper: {
    background: "var(--app-bg)",
    minHeight: "100vh",
    padding: "14px 28px 14px 20px",
    "@media (max-width:900px)": {
      paddingRight: "10px",
      paddingLeft: "10px",
    },
  },

  backBtn: {
    marginBottom: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    height: "34px",
    padding: "0 12px",
    border: "1px solid var(--app-border)",
    borderRadius: "7px",
    fontFamily: "Inter",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "var(--app-text)",
    backgroundColor: "transparent",
    cursor: "pointer",
    transition: "background .12s ease, border-color .12s ease, color .12s ease",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },

  settingsGrid: {
    display: "flex",
    gap: "20px",
    alignItems: "flex-start",
  },

  settingsSide: {
    width: "220px",
    flexShrink: 0,
    background: "var(--app-surface)",
    borderRadius: "14px",
    border: "1px solid var(--app-border)",
    padding: "10px 8px",
    position: "sticky",
    top: "24px",
  },

  sideSection: {
    marginBottom: "4px",
    "&:last-child": { marginBottom: 0 },
  },

  sideSectionLabel: {
    fontFamily: "Inter",
    fontSize: "10.5px",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "var(--app-text-muted)",
    padding: "8px 10px 4px",
    margin: 0,
  },

  sideItem: {
    display: "flex",
    alignItems: "center",
    gap: "9px",
    padding: "8px 10px",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "13.5px",
    fontWeight: 500,
    color: "#52525B",
    cursor: "pointer",
    border: "none",
    background: "transparent",
    width: "100%",
    textAlign: "left",
    transition: "background 0.1s ease",
    "&:hover": { background: "var(--app-surface-2)", color: "var(--app-text)" },
  },

  sideItemActive: {
    background: "#FFF4DA !important",
    color: "#92400E !important",
    fontWeight: 600,
  },

  sideItemIcon: {
    flexShrink: 0,
    fontSize: "15px",
  },

  settingsPanel: {
    flex: 1,
    minWidth: 0,
  },

  panelCard: {
    background: "var(--app-surface)",
    borderRadius: "14px",
    border: "1px solid var(--app-border)",
    padding: "24px 26px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },

  panelCardHeader: {
    marginBottom: "20px",
    paddingBottom: "16px",
    borderBottom: "1px solid #F3F3F3",
  },

  panelCardTitle: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "-0.2px",
  },

  panelCardDesc: {
    margin: "4px 0 0",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text-muted)",
  },

  panelCardHeadRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
  },

  addAccentBtn: {
    height: "40px",
    padding: "0 16px",
    borderRadius: "8px",
    background: "#F5A623",
    color: "var(--app-text)",
    border: 0,
    fontFamily: "Inter",
    fontSize: "13.5px",
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
    transition: "background .12s ease",
    "&:hover": { background: "#E09610" },
  },

  searchbar: {
    marginBottom: "16px",
  },

  // Preferences
  prefSectionLabel: {
    margin: "0 0 12px 0",
    fontFamily: "Inter",
    fontSize: "10.5px",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "var(--app-text-muted)",
  },

  prefSectionLabelSpaced: {
    margin: "22px 0 12px 0",
    fontFamily: "Inter",
    fontSize: "10.5px",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "var(--app-text-muted)",
  },

  prefFormGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "16px 18px",
  },

  prefField: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  prefFieldLabel: {
    fontFamily: "Inter",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#344054",
    margin: 0,
  },

  prefSelectWrapper: { width: "100%" },

  prefSelectInput: {
    height: "42px",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text)",
    background: "var(--app-surface)",
    "&:focus": { borderColor: "var(--app-primary)" },
  },

  prefSwitchRoot: {
    "& input:checked + label": {
      background: "var(--app-primary) !important",
      borderColor: "var(--app-accent) !important",
    },
  },

  prefSwitchTrack: {
    background: "#D4D4D8 !important",
    borderColor: "#D4D4D8 !important",
  },

  prefSwitchThumb: { background: "var(--app-surface)", border: "none" },

  prefRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 0",
    borderBottom: "1px solid #F3F3F3",
    gap: "16px",
    "&:last-child": { borderBottom: 0 },
  },

  prefRowInfo: { flex: 1, minWidth: 0 },

  prefRowTitle: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: "13.5px",
    fontWeight: 600,
    color: "var(--app-text)",
  },

  prefRowDesc: {
    margin: "2px 0 0",
    fontFamily: "Inter",
    fontSize: "12.5px",
    color: "var(--app-text-muted)",
    lineHeight: 1.5,
  },

  // Provider / payer row
  payerList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  payerRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "14px 16px",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    background: "var(--app-surface)",
    flexWrap: "wrap",
    transition: "background .12s ease",
    "&:hover": { background: "var(--app-surface-2)" },
  },

  payerRowSelected: {
    background: "#FFF4DA !important",
    borderColor: "#F5C518 !important",
  },

  payerRowInfo: { flex: 1, minWidth: "200px" },

  payerTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },

  payerRowH5: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
    fontFamily: "Inter",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },

  payerRowP: {
    margin: "4px 0 0",
    fontSize: "12px",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    lineHeight: 1.5,
  },

  payerRowActions: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },

  payerAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 8px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    color: "#52525B",
    background: "transparent",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": { background: "var(--app-surface-2)", color: "var(--app-text)" },
  },

  payerDeleteBtn: {
    width: "30px",
    height: "30px",
    borderRadius: "6px",
    background: "transparent",
    border: 0,
    color: "var(--app-text-muted)",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    "&:hover": { background: "#FEF2F2", color: "#B91C1C" },
  },

  statusInline: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    fontWeight: 500,
    color: "var(--app-text-muted)",
    whiteSpace: "nowrap",
    fontFamily: "Inter",
  },

  tipBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    background: "#FFF4DA",
    border: "1px solid #FAE7BE",
    borderRadius: "10px",
    padding: "12px 14px",
    marginBottom: "16px",
    fontSize: "13px",
    color: "#78350F",
    fontFamily: "Inter",
    lineHeight: 1.55,
    "& b, & strong": { color: "#92400E" },
  },

  tipIcon: {
    color: "#B7791F",
    flexShrink: 0,
    marginTop: "2px",
  },

  // Auth banner (amber warning)
  authBanner: {
    background: "#FEF6E3",
    border: "1px solid #F4D8A1",
    borderRadius: "10px",
    padding: "14px",
    margin: "14px 18px 0",
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  authBannerIco: {
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    background: "var(--app-surface)",
    border: "1px solid #F4D8A1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#8C5A18",
    "& svg": { width: "18px", height: "18px" },
  },

  authBannerTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#8C5A18",
    margin: 0,
    fontFamily: "Inter",
  },

  // Claims card
  claimsCard: {
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "12px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
    overflow: "hidden",
    margin: "14px 18px 18px",
  },

  claimsCardToolbar: {
    padding: "14px 20px",
    borderBottom: "1px solid var(--app-border)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },

  filterSegs: {
    display: "flex",
    gap: "6px",
    background: "var(--app-bg)",
    padding: "4px",
    borderRadius: "8px",
  },

  filterSeg: {
    padding: "6px 12px",
    borderRadius: "6px",
    border: 0,
    background: "transparent",
    color: "#525252",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "Inter",
    transition: "background .1s ease",
  },

  filterSegActive: {
    background: "var(--app-surface)",
    color: "var(--app-text)",
    boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
  },

  clientSearchWrap: {
    flex: 1,
    minWidth: "180px",
    position: "relative",
  },

  clientSearchInput: {
    "& .mantine-Input-input": {
      height: 40,
      paddingLeft: 38,
      border: "1px solid var(--app-border)",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter",
      color: "var(--app-text)",
      background: "var(--app-surface)",
      "&:focus": { borderColor: "var(--app-primary)" },
      "&::placeholder": { color: "var(--app-text-muted)" },
    },
  },

  tableScroll: {
    overflowX: "auto",
  },

  dataTable: {
    width: "100%",
    minWidth: "1020px",
    borderCollapse: "collapse",
    fontSize: "13px",
    "& thead": { background: "var(--app-surface-2)" },
    "& th": {
      textAlign: "left",
      padding: "12px 16px",
      fontSize: "11.5px",
      fontWeight: 600,
      color: "var(--app-text-muted)",
      borderBottom: "1px solid var(--app-border)",
      whiteSpace: "nowrap",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontFamily: "Inter",
    },
    "& td": {
      padding: "14px 16px",
      borderBottom: "1px solid #F1F1F1",
      color: "var(--app-text)",
      verticalAlign: "middle",
      whiteSpace: "nowrap",
      fontFamily: "Inter",
    },
    "& tbody tr": { cursor: "pointer", transition: "background .1s ease" },
    "& tbody tr:hover": { background: "var(--app-surface-2)" },
    "& tbody tr:last-child td": { borderBottom: 0 },
  },

  clientCell: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: "200px",
  },

  clientAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "999px",
    background: "var(--app-surface-2)",
    border: "2px solid var(--app-primary)",
    display: "grid",
    placeItems: "center",
    fontSize: "12px",
    fontWeight: 700,
    color: "var(--app-text)",
    flexShrink: 0,
    overflow: "hidden",
    fontFamily: "Inter",
  },

  clientName: {
    fontWeight: 600,
    color: "var(--app-text)",
    fontSize: "13px",
    fontFamily: "Inter",
    margin: 0,
  },

  clientSub: {
    fontSize: "11.5px",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    margin: 0,
  },

  authCodeCell: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text)",
  },

  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "3px 9px",
    borderRadius: "4px",
    fontSize: "11.5px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    border: "1px solid transparent",
    fontFamily: "Inter",
    "&::before": {
      content: '""',
      width: "6px",
      height: "6px",
      borderRadius: "999px",
      background: "currentColor",
    },
  },

  pillEligible: {
    color: "#2F7D5C",
    background: "#F3F8F0",
    borderColor: "#C6E2C9",
  },

  pillIneligible: {
    color: "#B91C1C",
    background: "#FEF2F2",
    borderColor: "#FECDCA",
  },

  pillUnverified: {
    color: "#2C5BA3",
    background: "#EFF6FF",
    borderColor: "#BFD4F0",
  },

  actionsCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  rowMenuBtn: {
    width: "32px",
    height: "32px",
    borderRadius: "7px",
    background: "transparent",
    border: "1px solid transparent",
    color: "var(--app-text-muted)",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    transition: "background .1s ease",
    "&:hover": {
      background: "var(--app-surface-2)",
      color: "var(--app-text)",
      borderColor: "var(--app-border)",
    },
    "& svg": { width: "16px", height: "16px" },
  },

  clientWarningIcon: {
    marginLeft: "6px",
    verticalAlign: "middle",
  },

  panelCardNoPad: {
    background: "var(--app-surface)",
    borderRadius: "14px",
    border: "1px solid var(--app-border)",
    padding: 0,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },

  panelCardHeaderInner: {
    padding: "24px 26px 20px",
    borderBottom: "1px solid #F3F3F3",
  },

  tableThRight: {
    textAlign: "right",
  },

  tableThPadL: {
    paddingLeft: "22px !important",
  },

  tableThPadR: {
    textAlign: "right",
    paddingRight: "22px !important",
  },

  tableTdPadL: {
    paddingLeft: "22px !important",
  },

  tableTdPadR: {
    textAlign: "right",
    paddingRight: "22px !important",
  },

  tableEmptyCell: {
    textAlign: "center",
    padding: "40px 16px",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
  },

  actionsCellEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "2px",
  },

  rowMenuContainer: {
    position: "relative",
    display: "inline-block",
  },

  rowMenuPop: {
    position: "absolute",
    top: "calc(100% + 4px)",
    right: 0,
    minWidth: "220px",
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    boxShadow: "0 12px 32px rgba(15,23,42,0.14)",
    zIndex: 50,
    padding: "4px",
  },

  rowMenuPopItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    padding: "8px 10px",
    background: "transparent",
    border: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "13px",
    color: "var(--app-text)",
    cursor: "pointer",
    borderRadius: "6px",
    textAlign: "left",
    whiteSpace: "nowrap",
    "& svg": { width: "14px", height: "14px", color: "var(--app-text-muted)", flexShrink: 0 },
    "&:hover": { background: "var(--app-surface-2)", color: "var(--app-text)" },
    "&:hover svg": { color: "var(--app-text)" },
  },

  authExpiredIcon: {
    display: "inline-grid",
    placeItems: "center",
    width: "16px",
    height: "16px",
    borderRadius: "999px",
    background: "#DC2626",
    color: "var(--app-on-primary)",
    fontSize: "11px",
    fontWeight: 800,
    lineHeight: 1,
    cursor: "pointer",
    border: 0,
    padding: 0,
    fontFamily: "inherit",
    flexShrink: 0,
    transition: "transform .12s ease, box-shadow .12s ease",
    "&:hover": {
      transform: "scale(1.12)",
      boxShadow: "0 0 0 3px rgba(220,38,38,0.18)",
    },
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "18px",
    fontWeight: 400,
    textAlign: "center",
  },

  emptyBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "240px",
    gap: "16px",
  },

  receiptsEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "260px",
    gap: "10px",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "14px",
  },

  // Receipt view modal
  rcModalOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 350,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  rcModal: {
    width: "100%",
    maxWidth: "620px",
    maxHeight: "92vh",
    background: "var(--app-surface)",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
  },
  rcModalHead: {
    padding: "22px 28px",
    borderBottom: "1px solid #F1F1F1",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    flexShrink: 0,
  },
  rcModalEyebrow: {
    margin: 0,
    fontSize: "11px",
    fontWeight: 700,
    color: "#B7791F",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    fontFamily: "Inter",
  },
  rcModalTitle: {
    margin: "4px 0 0",
    fontSize: "22px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "-0.018em",
    fontFamily: "Inter",
  },
  rcModalSub: {
    margin: "2px 0 0",
    fontSize: "12.5px",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
  },
  rcModalClose: {
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    background: "var(--app-surface-2)",
    border: 0,
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    color: "var(--app-text)",
    flexShrink: 0,
    "& svg": { width: "18px", height: "18px" },
    "&:hover": { background: "#E4E4E7" },
  },
  rcModalBody: {
    padding: "22px 28px",
    overflowY: "auto",
    flex: 1,
  },
  rcLetterhead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "16px 18px",
    background: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
    marginBottom: "18px",
  },
  rcLetterheadLeft: { display: "flex", flexDirection: "column", gap: "2px" },
  rcBrand: { fontSize: "16px", fontWeight: 800, color: "var(--app-text)", letterSpacing: "-0.012em", fontFamily: "Inter" },
  rcBrandSub: { fontSize: "12px", fontWeight: 600, color: "var(--app-text)", fontFamily: "Inter" },
  rcBrandMeta: { fontSize: "11.5px", color: "var(--app-text-muted)", marginTop: "4px", fontFamily: "Inter" },
  rcPaidStamp: {
    display: "inline-block",
    fontSize: "14px",
    fontWeight: 800,
    letterSpacing: "0.16em",
    color: "#047857",
    background: "#DCFCE7",
    border: "2px solid #86E1B0",
    borderRadius: "8px",
    padding: "8px 16px",
    transform: "rotate(-6deg)",
    fontFamily: "Inter",
  },
  rcKvGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
  },
  rcKv: {
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    padding: "10px 12px",
  },
  rcKvKey: {
    fontSize: "11px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "4px",
    fontFamily: "Inter",
  },
  rcKvVal: { fontSize: "13px", fontWeight: 700, color: "var(--app-text)", fontFamily: "Inter" },
  rcSectionLabel: {
    margin: "20px 0 8px",
    fontSize: "11.5px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "Inter",
  },
  rcLines: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    overflow: "hidden",
    fontSize: "13px",
    fontFamily: "Inter",
    "& thead th": {
      background: "var(--app-surface-2)",
      fontSize: "11px",
      fontWeight: 700,
      color: "var(--app-text-muted)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      padding: "10px 12px",
      textAlign: "left",
      borderBottom: "1px solid var(--app-border)",
    },
    "& th.r, & td.r": { textAlign: "right" },
    "& tbody td": { padding: "12px", color: "var(--app-text)" },
    "& tfoot td": {
      padding: "12px",
      background: "var(--app-surface-2)",
      borderTop: "1px solid var(--app-border)",
      fontWeight: 800,
      color: "var(--app-text)",
    },
  },
  rcFootnote: {
    margin: "16px 0 0",
    fontSize: "12px",
    color: "var(--app-text-muted)",
    lineHeight: 1.55,
    fontFamily: "Inter",
  },
  rcModalFoot: {
    padding: "16px 28px 22px",
    borderTop: "1px solid #F1F1F1",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexShrink: 0,
  },
  rcCloseBtn: {
    height: "40px",
    padding: "0 16px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    color: "var(--app-text)",
    fontSize: "13.5px",
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "Inter",
    "&:hover": { background: "var(--app-surface-2)" },
  },
  rcDownloadBtn: {
    height: "40px",
    padding: "0 16px",
    borderRadius: "8px",
    border: 0,
    background: "var(--app-primary)",
    color: "var(--app-text)",
    fontSize: "13.5px",
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "Inter",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    "& svg": { width: "16px", height: "16px" },
    "&:hover": { background: "var(--app-primary)", filter: "brightness(0.95)" },
  },

  linesTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    "& th, & td": {
      padding: "10px 12px",
      borderBottom: "1px solid #F1F1F1",
      textAlign: "left",
      fontFamily: "Inter",
    },
    "& th": {
      background: "var(--app-surface-2)",
      fontSize: "11px",
      fontWeight: 600,
      color: "var(--app-text-muted)",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    },
    "& td": { color: "var(--app-text)" },
    "& tbody tr": { cursor: "pointer", transition: "background .1s ease" },
    "& tbody tr:hover": { background: "var(--app-surface-2)" },
    "& tbody tr:last-child td": { borderBottom: 0 },
  },

  rcActionBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    background: "transparent",
    border: 0,
    borderRadius: "6px",
    color: "var(--app-text-muted)",
    cursor: "pointer",
    transition: "background .1s ease, color .1s ease",
    "&:hover": { background: "var(--app-surface-2)", color: "var(--app-text)" },
    "& svg": { width: "16px", height: "16px" },
  },

  // Payer search table
  header: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 700,
    color: "var(--app-text)",
  },

  row: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    color: "var(--app-text)",
  },

  tableRoot: {
    "tbody tr:hover td": { backgroundColor: "#FFF6ED !important" },
  },

  button: {
    "&:hover": { background: "var(--app-primary)", color: "var(--app-surface)", opacity: 0.8 },
  },

  searchbox: {
    width: "100%",
    marginBottom: "10px",
  },

  // Payer add bar (hidden by default, shown when "Add Payer" clicked)
  payerAddBar: {
    marginBottom: "14px",
  },

  // Payer search dropdown
  payerSearchWrap: {
    position: "relative",
  },

  payerSearchInput: {
    "& .mantine-Input-input": {
      height: 42,
      paddingLeft: 38,
      border: "1px solid var(--app-border)",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter",
      color: "var(--app-text)",
      "&:focus": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px rgba(23,23,23,0.08)",
      },
    },
  },

  searchResults: {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: 0,
    right: 0,
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    zIndex: 300,
    overflow: "hidden",
    maxHeight: 320,
    display: "flex",
    flexDirection: "column",
  },

  searchResultsBody: {
    overflowY: "auto",
    flex: 1,
  },

  searchResultsHead: {
    padding: "10px 16px",
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "var(--app-text-muted)",
    borderBottom: "1px solid #F3F3F3",
    background: "var(--app-surface-2)",
    flexShrink: 0,
  },

  searchResult: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    gap: "12px",
    borderBottom: "1px solid var(--app-bg)",
    "&:last-of-type": { borderBottom: 0 },
    "&:hover": { background: "#FFF9F0" },
    "& .info": { flex: 1, minWidth: 0 },
    "& h5": {
      margin: 0,
      fontFamily: "Inter",
      fontSize: "13.5px",
      fontWeight: 600,
      color: "var(--app-text)",
      lineHeight: 1.4,
    },
    "& p": {
      margin: "3px 0 0",
      fontFamily: "Inter",
      fontSize: "12px",
      color: "var(--app-text-muted)",
      lineHeight: 1.4,
    },
  },

  searchResultAdd: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#B7791F",
    padding: "4px 10px",
    background: "#FFF4DA",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
    flexShrink: 0,
    fontFamily: "Inter",
    whiteSpace: "nowrap",
    "&:hover": { background: "#FAE7BE" },
  },

  searchResultsFoot: {
    padding: "10px 14px",
    borderTop: "1px solid #F0F0F0",
    background: "var(--app-surface-2)",
    fontFamily: "Inter",
    fontSize: "12.5px",
    color: "var(--app-text-muted)",
    flexShrink: 0,
    "& a, & button": {
      background: "none",
      border: 0,
      padding: 0,
      color: "#B7791F",
      fontWeight: 600,
      cursor: "pointer",
      fontFamily: "Inter",
      fontSize: "12.5px",
      textDecoration: "none",
      "&:hover": { textDecoration: "underline" },
    },
  },

  prefFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "22px",
    paddingTop: "18px",
    borderTop: "1px solid #F3F3F3",
  },

  wizardLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    height: "34px",
    padding: "0 12px",
    background: "transparent",
    border: "1px solid var(--app-border)",
    borderRadius: "7px",
    fontFamily: "Inter",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "var(--app-text)",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background .12s ease, border-color .12s ease",
    flexShrink: 0,
    "&:hover": { background: "var(--app-surface-2)" },
  },

  saveChangesBtn: {
    height: "40px",
    padding: "0 20px",
    background: "var(--app-primary)",
    border: 0,
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
    cursor: "pointer",
    "&:hover": { background: "#FAA030" },
  },
}));


const BillingSettings = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [activeTab, setActiveTab] = useState(location?.state?.tab || "preferences");
  const [currentPage, setCurrentPage] = useState(1);

  const [prefs, setPrefs] = useState({
    claimFormat: "professional",
    autoEvv: "yes",
    eligibilityCheck: true,
    autoBillingNotes: false,
    autoPollStatus: true,
    emailOnRejection: true,
    manualOverride: true,
  });

  // modals — Add* components use state.addProvider / state.addPayer / state.addClient keys
  const [state, setState] = useState({
    addProvider: false,
    addPayer: false,
    addClient: false,
  });
  const [editprovider, setEditProvider] = useState(false);
  const [EditPayerModalOpen, setEditPayerModalOpen] = useState(false);
  const [editclient, setEditclient] = useState(false);
  const [providerEnrollment, setProviderEnrollment] = useState(false);
  const [view, setView] = useState(false);

  const [provideritem, setProvideritem] = useState(null);
  const [editPayerItem, setEditPayerItem] = useState(null);
  const [editClientItem, setEditClientItem] = useState(null);

  const [providerSearch, setProviderSearch] = useState("");
  const [payerSearch, setPayerSearch] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  const [clientFilter, setClientFilter] = useState("All");
  const debouncedClientSearch = useDebounce(clientSearch, 300);
  const [eligibilityModalOpen, setEligibilityModalOpen] = useState(false);
  const [eligibilityPatient, setEligibilityPatient] = useState(null);
  const [receiptModal, setReceiptModal] = useState({ opened: false, receipt: null });
  const [receiptsPage, setReceiptsPage] = useState(1);

  // Payer search
  const [payerValue, setPayerValue] = useState("");
  const [selectedPayer, setSelectedPayer] = useState(null);
  const [searchloading, setSearchLoading] = useState(false);
  const [payerDropdownOpen, setPayerDropdownOpen] = useState(false);
  const [showPayerSearch, setShowPayerSearch] = useState(false);
  const payerSearchRef = useRef(null);

  const [paymentype, setPaymentType] = useState("");
  const [achservices, setAchServices] = useState({
    accountNumber: "",
    routingNumber: "",
    bankName: "",
    accountholdername: "",
  });

  const { loading, allbillingprovider } = useSelector(
    (state) => state.billingprovider,
  );
  const {
    allpayer,
    alllistpayer,
    loading: payerLoading,
  } = useSelector((state) => state.payer);
  const { allbillingclient } = useSelector((state) => state?.billingclient);
  const { patients, loading: patientLoading } = useSelector((state) => state.patient);
  const { profile, saveProfileLoading } = useSelector((state) => state?.profile);
  const { allbillingPayments, allBilling } = useSelector((state) => state.billing);

  useEffect(() => {
    getServicecode();
    getProccode();
    getAllFacilitiesModal();
  }, []);

  useEffect(() => {
    if (profile?.user?.billingPreferences) {
      const bp = profile.user.billingPreferences;
      setPrefs((p) => ({
        ...p,
        claimFormat: bp.claimFormat || p.claimFormat,
        autoEvv: bp.autoEvv || p.autoEvv,
        eligibilityCheck: bp.eligibilityCheck ?? p.eligibilityCheck,
        autoBillingNotes: bp.autoBillingNotes ?? p.autoBillingNotes,
        autoPollStatus: bp.autoPollStatus ?? p.autoPollStatus,
        emailOnRejection: bp.emailOnRejection ?? p.emailOnRejection,
        manualOverride: bp.manualOverride ?? p.manualOverride,
      }));
    }
  }, [profile]);

  useEffect(() => {
    setCurrentPage(1);
    if (activeTab === "provider") {
      getBillingProvider({ page: 1 });
    } else if (activeTab === "payer") {
      getpayer({ page: 1 });
      getpayerlist();
    } else if (activeTab === "client") {
      getAllPatients(currentPage, true, true);
      getBillingProvider({ page: 1 });
      getpayer({ page: 1 });
      getAllBillingModal({ page: 'all' });
    } else if (activeTab === "receipts") {
      setReceiptsPage(1);
      getAllBillingPayments({ page: 1 });
    } else if (activeTab === "payment") {
      getAllBillingPayments({ page: 1 });
      // getBillingCard();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "provider") {
      getBillingProvider({ page: currentPage });
    } else if (activeTab === "payer") {
      getpayer({ page: currentPage });
    } else if (activeTab === "client") {
      // Skip paginated fetch when search/filter is active — the search effect handles it
      if (!clientSearch && clientFilter === "All") {
        getAllPatients(currentPage, true, true);
      }
    }
  }, [currentPage]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        payerSearchRef.current &&
        !payerSearchRef.current.contains(e.target)
      ) {
        setPayerDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPayerSearch]);

  // When search or filter tab is active, fetch all clients (no pagination limit)
  // so results are not restricted to the current page.
  useEffect(() => {
    if (activeTab !== "client") return;
    if (debouncedClientSearch || clientFilter !== "All") {
      getAllPatients("all", true, true);
    } else {
      setCurrentPage(1);
      getAllPatients(1, true, true);
    }
  }, [debouncedClientSearch, clientFilter]);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleSavePrefs = async () => {
    await updateProfile({ billingPreferences: prefs });
  };

  // Provider handlers
  const handleRmoveProvider = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      removeProvider({ id });
      getBillingProvider({ page: currentPage });
    }
  };

  const handleEditProvider = (item, viewOnly) => {
    setView(viewOnly);
    setProvideritem(item);
    setEditProvider(true);
  };

  const handleProviderEnrollment = (item) => {
    setProvideritem(item);
    setProviderEnrollment(true);
  };

  const SearchBillingProvider = async (val) => {
    setProviderSearch(val);
    await getBillingProvider({ name: val, page: 1 });
  };

  // Payer handlers
  const handleremovePayer = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removepayer({ id });
  };

  const handleEditPayer = (payer, viewOnly) => {
    setView(viewOnly);
    setEditPayerItem(payer);
    setEditPayerModalOpen(true);
  };

  const SearchBillingPayer = async (val) => {
    setPayerSearch(val);
    await getpayer({ name: val, page: 1 });
  };

  const clearsearch = async () => {
    setSelectedPayer(null);
    setPayerValue("");
    await getpayer({ page: 1 });
  };

  const handleAddPayer = async (selectedPayerItem) => {
    try {
      let values = {
        payerName: selectedPayerItem?.payer_name,
        payerId: selectedPayerItem?.payer_id,
        stediPayerId:selectedPayerItem?.stedi_id,
        payerState: selectedPayerItem.payer_state || "AZ",
        payerCity: "Phoenix",
        payerZip: "86052",
        payerAddress1: "1 2 3 street",
      };

      let payload = {
        values,
        createdBy: profile.user.id,
        // admin: profile?.user?.admin ?? profile?.user?.id,
        admin:(profile?.user?.admin && profile?.user?.role) ? profile?.user?.admin : profile?.user?.id,
      };
      const res = await createpayer(payload);

      if (res.status === 200) {
        setSelectedPayer(null);
        setPayerValue("");
        getpayer({ page: 1 });
        swal({
          title: "Payer added successfully",
          text: "Payer added successfully",
          dangerMode: false,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // Called by VerifyEligibilityModal after a successful check — saves lastVerified to the patient record
  const handleEligibilityVerified = (patient, isoTimestamp) => {
    const updated = {
      ...patient,
      form2: {
        ...patient.form2,
        BillingInsurance: (patient.form2?.BillingInsurance || []).map((ins, idx) =>
          idx === 0 ? { ...ins, lastVerified: isoTimestamp } : ins
        ),
      },
    };
    editPatient(updated, false, 1, true);
  };

  // Build a map of patientFullName → open claim count (status not Paid/"P")
  const openClaimsMap = (() => {
    const map = {};
    const billingList = allBilling?.Billing || [];
    billingList.forEach((record) => {
      (record?.billingForm?.claim || []).forEach((claim) => {
        if (claim?.deleted) return;
        const fullName = `${claim.pat_name_f || ""} ${claim.pat_name_l || ""}`.trim().toLowerCase();
        if (!fullName) return;
        if (claim.status !== "P") {
          map[fullName] = (map[fullName] || 0) + 1;
        }
      });
    });
    return map;
  })();

  // Client handlers
  const handleEditClient = (item, viewOnly) => {
    setView(viewOnly);
    setEditClientItem(item);
    setEditclient(true);
  };

  // --- Panel renders ---

  const renderPreferences = () => (
    <Box className={classes.panelCard}>
      <Box className={classes.panelCardHeader}>
        <Box className={classes.panelCardHeadRow}>
          <Box>
            <h3 className={classes.panelCardTitle}>Claim Preferences</h3>
            <p className={classes.panelCardDesc}>
              Defaults applied to every new claim. Override on individual claims
              as needed.
            </p> 
          </Box>
          <Button
            variant="default"
            leftIcon={<LuRefreshCw size={14} />}
            className={classes.wizardLink}
            onClick={() => navigate("/home/billing-claim-form")}
          >
            Re-run setup wizard
          </Button>
        </Box>
      </Box>

      <h6 className={classes.prefSectionLabel}>Default claim type</h6>
      <div className={classes.prefFormGrid}>
        <div className={classes.prefField}>
          <label className={classes.prefFieldLabel}>Default claim format</label>
          <Select
            value={prefs.claimFormat}
            disabled
            onChange={(v) => setPrefs((p) => ({ ...p, claimFormat: v }))}
            data={[
              { value: "professional", label: "Professional (CMS-1500 / 837P)" },
              { value: "institutional", label: "Institutional (UB-04 / 837I)" },
            ]}
            classNames={{ input: classes.prefSelectInput, wrapper: classes.prefSelectWrapper }}
            rightSection={<BiChevronDown size={18} style={{ color: "var(--app-text-muted)" }} />}
            rightSectionWidth={28}
            styles={{ rightSection: { pointerEvents: "none" } }}
          />
        </div>
        <div className={classes.prefField}>
          <label className={classes.prefFieldLabel}>Auto-attach EVV visit data</label>
          <Select
            value={prefs.autoEvv}
            disabled
            onChange={(v) => setPrefs((p) => ({ ...p, autoEvv: v }))}
            data={[
              { value: "yes", label: "Yes, when available" },
              { value: "no", label: "Never" },
            ]}
            classNames={{ input: classes.prefSelectInput, wrapper: classes.prefSelectWrapper }}
            rightSection={<BiChevronDown size={18} style={{ color: "var(--app-text-muted)" }} />}
            rightSectionWidth={28}
            styles={{ rightSection: { pointerEvents: "none" } }}
          />
        </div>
      </div>

      <h6 className={classes.prefSectionLabelSpaced}>Submission behavior</h6>
      {[
        { key: "eligibilityCheck", title: "Run eligibility check before submission", desc: "Block submission if the client's eligibility is stale (older than 30 days) or marked ineligible." },
        { key: "autoBillingNotes", title: "Use billing progress notes automatically", desc: "When a Billing Services note exists for the period, pull its service units into the claim." },
        { key: "autoPollStatus", title: "Auto-poll claim status", desc: "Check the clearinghouse every hour for status updates on submitted claims." },
        { key: "emailOnRejection", title: "Email me when a claim is rejected", desc: "Sends an email to the admin within 5 minutes of any rejection." },
        { key: "manualOverride", title: "Allow manual billing override", desc: 'Show "Manual Billing" mode where service units can be entered by hand instead of pulled from notes.' },
      ].map((row) => (
        <div key={row.key} className={classes.prefRow}>
          <div className={classes.prefRowInfo}>
            <p className={classes.prefRowTitle}>{row.title}</p>
            <p className={classes.prefRowDesc}>{row.desc}</p>
          </div>
          <Switch
            checked={!!prefs[row.key]}
            onChange={(e) => { const v = e.currentTarget.checked; setPrefs((p) => ({ ...p, [row.key]: v })); }}
            size="md"
            classNames={{ root: classes.prefSwitchRoot, track: classes.prefSwitchTrack, thumb: classes.prefSwitchThumb }}
          />
        </div>
      ))}

      <Box className={classes.prefFooter}>
        <Button
          className={classes.saveChangesBtn}
          onClick={handleSavePrefs}
          loading={saveProfileLoading}
          loaderPosition="right"
        >
          Save Changes
        </Button>
      </Box>
    </Box>
  );

  const renderProvider = () => (
    <Box className={classes.panelCard}>
      <Box className={classes.panelCardHeader}>
        <Box className={classes.panelCardHeadRow}>
          <Box>
            <h3 className={classes.panelCardTitle}>Billing Providers</h3>
            <p className={classes.panelCardDesc}>
              The legal entities or individuals that submit your claims. Add as
              many providers as you bill under.
            </p>
          </Box>
          <Box
            component="button"
            className={classes.addAccentBtn}
            onClick={() => setState((p) => ({ ...p, addProvider: true }))}
          >
            <LuPlus size={15} />
            Add Provider
          </Box>
        </Box>
      </Box>

      <Box className={classes.searchbar}>
        <BillingSearchAll
          placeholder="Search providers you've added"
          onChange={SearchBillingProvider}
          value={providerSearch}
          setValue={setProviderSearch}
        />
      </Box>

      {loading ? (
        <TableLoader />
      ) : allbillingprovider?.billingprovider?.length > 0 ? (
        <>
          <Box className={classes.payerList}>
            {allbillingprovider.billingprovider.map((item) => {
              const isIncomplete =
                !item?.name ||
                !item?.address ||
                !item?.phone ||
                !item?.zipcode ||
                !item?.federalTaxID ||
                !item?.billingIdentifier ||
                !item?.taxonomy ||
                !item?.serviceCode ||
                !item?.state ||
                !item?.city ||
                item?.providerEnrollment === false;

              return (
                <Box key={item.id} className={classes.payerRow}>
                  <Box className={classes.payerRowInfo}>
                    <Box className={classes.payerTitleRow}>
                      <h5 className={classes.payerRowH5}>
                        {item?.name || "-"}
                        {isIncomplete && (
                          <Tooltip
                            label={
                              <>
                                {!item?.providerEnrollment && (
                                  <>
                                    Provider is not enrolled in Claim MD
                                    <br />
                                  </>
                                )}
                                {(!item?.name ||
                                  !item?.address ||
                                  !item?.phone ||
                                  !item?.zipcode ||
                                  !item?.federalTaxID ||
                                  !item?.billingIdentifier ||
                                  !item?.taxonomy ||
                                  !item?.serviceCode ||
                                  !item?.state ||
                                  !item?.city) &&
                                  "Provider Details Incomplete"}
                              </>
                            }
                            withArrow
                            position="bottom"
                          >
                            <img
                              width={16}
                              src="/assets/images/error.png"
                              alt="warning"
                            />
                          </Tooltip>
                        )}
                      </h5>
                      <span className={classes.statusInline}>
                        {item?.providertype || "-"}
                      </span>
                    </Box>
                    <p className={classes.payerRowP}>
                      {[
                        (() => { const bi = item?.billingIdentifier; const n = bi ? (typeof bi === "object" ? bi?.number || "" : bi) : ""; return n ? `NPI ${n}` : null; })(),
                        item?.federalTaxID?.number
                          ? `Tax ID ${item.federalTaxID.number}${item.federalTaxID.type ? ` (${item.federalTaxID.type})` : ""}`
                          : null,
                        item?.taxonomy ? `Taxonomy ${item.taxonomy}` : null,
                        item?.serviceCode?.name || null,
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                    </p>
                    <p className={classes.payerRowP}>
                      {[
                        item?.address,
                        item?.city && item?.state && item?.zipcode
                          ? `${item.city} ${item.state} ${item.zipcode}`
                          : item?.city || item?.state || item?.zipcode || null,
                        item?.phone || null,
                        item?.services?.length
                          ? `${item.services.length} services`
                          : null,
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                    </p>
                  </Box>
                  <Box
                    className={classes.payerRowActions}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Box
                      component="button"
                      className={classes.payerAction}
                      onClick={() => handleEditProvider(item, true)}
                    >
                      View
                    </Box>
                    <Box
                      component="button"
                      className={classes.payerAction}
                      onClick={() => handleEditProvider(item, false)}
                    >
                      Edit
                    </Box>
                    {!item?.providerEnrollment && (
                      <Box
                        component="button"
                        className={classes.payerAction}
                        onClick={() => handleProviderEnrollment(item)}
                      >
                        Enroll
                      </Box>
                    )}
                    <Box
                      component="button"
                      className={classes.payerDeleteBtn}
                      onClick={() => handleRmoveProvider(item.id)}
                      title="Remove provider"
                    >
                      <IconTrash size={15} />
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Center mt={16}>
            <CustomBillingPagination
              data={allbillingprovider?.count}
              itemsPerPage={10}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </Center>
        </>
      ) : (
        <Box className={classes.emptyBox}>
          <RecordNotFound />
          <Center>
            <p className={classes.notFoundText}>
              No providers added yet. Click &quot;Add Provider&quot; to get
              started.
            </p>
          </Center>
        </Box>
      )}
    </Box>
  );

  const renderPayer = () => {
    return (
      <Box className={classes.panelCard}>
        <Box className={classes.panelCardHeader}>
          <Box className={classes.panelCardHeadRow}>
            <Box>
              <h3 className={classes.panelCardTitle}>Payers</h3>
              <p className={classes.panelCardDesc}>
                Manage insurance companies you submit claims to.
              </p>
            </Box>
            <Box
              component="button"
              className={classes.addAccentBtn}
              onClick={() => {
                setShowPayerSearch((prev) => !prev);
                if (!showPayerSearch) {
                  getpayerlist();
                  setPayerDropdownOpen(false);
                  setPayerValue("");
                }
              }}
            >
              <LuPlus size={15} />
              Add Payer
            </Box>
          </Box>
        </Box>

        {/* Search bar: hidden by default, shown when "Add Payer" clicked */}
        {showPayerSearch && (
          <Box className={classes.payerAddBar} ref={payerSearchRef}>
            <Box className={classes.payerSearchWrap}>
              <TextInput
                className={classes.payerSearchInput}
                placeholder="Search to add a new payer (Aetna, BCBS, Medicaid, UnitedHealthcare, …)"
                icon={<IconSearch size={16} color="var(--app-text-muted)" />}
                value={payerValue}
                onChange={(e) => {
                  const val = e.target.value;
                  setPayerValue(val);
                  setPayerDropdownOpen(true);
                  getpayerlist(val || undefined);
                }}
                onFocus={() => {
                  setPayerDropdownOpen(true);
                  if (
                    !Array.isArray(alllistpayer) ||
                    alllistpayer.length === 0
                  ) {
                    getpayerlist();
                  }
                }}
              />

              {payerDropdownOpen && (
                <Box className={classes.searchResults}>
                  {payerLoading ? (
                    <Box p="sm">
                      <TableLoader />
                    </Box>
                  ) : Array.isArray(alllistpayer) && alllistpayer.length > 0 ? (
                    <>
                      <Box className={classes.searchResultsHead}>
                        Matching payers
                      </Box>
                      <Box className={classes.searchResultsBody}>
                        {alllistpayer.map((item, idx) => (
                          <Box
                            key={item._id || idx}
                            className={classes.searchResult}
                          >
                            <div className="info">
                              <h5>{item.payer_name}</h5>
                              <p>
                                {[
                                  item.payerid
                                    ? `Payer ID ${item.payerid}`
                                    : null,
                                  item.payer_type || null,
                                ]
                                  .filter(Boolean)
                                  .join(" · ")}
                              </p>
                            </div>
                            <Box
                              component="button"
                              className={classes.searchResultAdd}
                              onClick={() => {
                                handleAddPayer(item);
                                setPayerValue("");
                                setPayerDropdownOpen(false);
                                setShowPayerSearch(false);
                              }}
                            >
                              + Add
                            </Box>
                          </Box>
                        ))}
                      </Box>
                      <Box className={classes.searchResultsFoot}>
                        Don&apos;t see your payer?{" "}
                        <button
                          onClick={() => {
                            setPayerValue("");
                            setPayerDropdownOpen(false);
                            setShowPayerSearch(false);
                            setState((p) => ({ ...p, addPayer: true }));
                          }}
                        >
                          Add a custom payer
                        </button>
                      </Box>
                    </>
                  ) : (
                    <Box className={classes.searchResultsFoot}>
                      No results.{" "}
                      <button
                        onClick={() => {
                          setPayerValue("");
                          setPayerDropdownOpen(false);
                          setShowPayerSearch(false);
                          setState((p) => ({ ...p, addPayer: true }));
                        }}
                      >
                        Add a custom payer
                      </button>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Added payers list */}
        {allpayer?.payer?.length > 0 ? (
          <>
            <Box className={classes.payerList}>
              {allpayer.payer.map((payer, index) => {
                const metaParts = [
                  payer.payerId ? `Payer ID ${payer.payerId}` : null,
                  payer.payerEntity || null,
                ].filter(Boolean);

                const isIncomplete =
                  !payer?.payerName ||
                  !payer?.payerId ||
                  !payer?.payerAddress1 ||
                  !payer?.payerCity ||
                  !payer?.payerState ||
                  !payer?.payerZip;

                return (
                  <Box
                    key={index}
                    className={classes.payerRow}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Box className={classes.payerRowInfo}>
                      <Box className={classes.payerTitleRow}>
                        <h5 className={classes.payerRowH5}>
                          {payer.payerName || "-"}
                          {isIncomplete && (
                            <Tooltip
                              label="Payer Details Incomplete"
                              withArrow
                              position="bottom"
                            >
                              <img
                                width={16}
                                src="/assets/images/error.png"
                                alt="warning"
                              />
                            </Tooltip>
                          )}
                        </h5>
                      </Box>
                      {metaParts.length > 0 && (
                        <p className={classes.payerRowP}>
                          {metaParts.join(" · ")}
                        </p>
                      )}
                    </Box>
                    <Box className={classes.payerRowActions}>
                      <Box
                        component="button"
                        className={classes.payerAction}
                        onClick={() => handleEditPayer(payer, true)}
                      >
                        View
                      </Box>
                      <Box
                        component="button"
                        className={classes.payerAction}
                        onClick={() => handleEditPayer(payer, false)}
                      >
                        Edit
                      </Box>
                      <Box
                        component="button"
                        className={classes.payerDeleteBtn}
                        onClick={() => handleremovePayer(payer.id)}
                        title="Remove payer"
                      >
                        <LuTrash2 size={15} />
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
            <Center mt={16}>
              <CustomBillingPagination
                data={allpayer?.count}
                itemsPerPage={10}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            </Center>
          </>
        ) : (
          <Box className={classes.emptyBox}>
            <RecordNotFound />
            <Center>
              <p className={classes.notFoundText}>
                No payers added yet. Search above to add a payer.
              </p>
            </Center>
          </Box>
        )}
      </Box>
    );
  };

  const renderClient = () => {
    const patientList = patients?.patients || [];
    console.log("🚀 ~ renderClient ~ patientList:", patientList)

    const expiredCount = patientList.filter((p) => {
      const endDate = p?.form2?.BillingInsurance?.[0]?.authorizationEndDate;
      return endDate
        ? moment
            .tz(endDate, userTimezone)
            .isBefore(moment.tz(new Date(), userTimezone), "day")
        : false;
    }).length;

    const searchLower = clientSearch.toLowerCase();
    const filtered = patientList.filter((p) => {
      if (clientSearch && !p?.name?.toLowerCase().includes(searchLower))
        return false;
      if (clientFilter === "All") return true;
      const endDate = p?.form2?.BillingInsurance?.[0]?.authorizationEndDate;
      const isExpired = endDate
        ? moment
            .tz(endDate, userTimezone)
            .isBefore(moment.tz(new Date(), userTimezone), "day")
        : false;
      if (clientFilter === "Error") return isExpired;
      if (clientFilter === "Eligible")
        return !isExpired && !!p?.form2?.BillingInsurance?.[0]?.payer;
      if (clientFilter === "Verification")
        return !isExpired && !p?.form2?.BillingInsurance?.[0]?.payer;
      return true;
    });

    const getInitials = (name) => {
      if (!name) return "?";
      return name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    };

    const getEligibilityPill = (patient) => {
      const endDate =
        patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate;
      const hasPayer = !!patient?.form2?.BillingInsurance?.[0]?.payer;
      const isExpired = endDate
        ? moment
            .tz(endDate, userTimezone)
            .isBefore(moment.tz(new Date(), userTimezone), "day")
        : false;
      if (isExpired) {
        return (
          <span className={`${classes.pill} ${classes.pillIneligible}`}>
            Ineligible
          </span>
        );
      }
      if (!hasPayer) {
        return (
          <span className={`${classes.pill} ${classes.pillUnverified}`}>
            Verification needed
          </span>
        );
      }
      return (
        <span className={`${classes.pill} ${classes.pillEligible}`}>
          Eligible
        </span>
      );
    };

    const totalPages = Math.ceil((patients?.count || 0) / 10);

    return (
      <Box className={classes.panelCardNoPad}>
        <Box className={classes.panelCardHeaderInner}>
          <Box className={classes.panelCardHeadRow}>
            <Box>
              <h3 className={classes.panelCardTitle}>Clients</h3>
              <p className={classes.panelCardDesc}>
                Clients enrolled in billing. Run eligibility checks and manage
                from this list.
              </p>
            </Box>
            {/* <Box
              component="button"
              className={classes.addAccentBtn}
              onClick={() => setState((p) => ({ ...p, addClient: true }))}
            >
              <LuPlus size={15} />
              Add Client
            </Box> */}
          </Box>
        </Box>

        {expiredCount > 0 && (
          <Box className={classes.authBanner}>
            <Box className={classes.authBannerIco}>
              <LuAlertTriangle size={18} />
            </Box>
            <Box>
              <p className={classes.authBannerTitle}>
                {expiredCount} client authorization
                {expiredCount > 1 ? "s have" : " has"} expired
              </p>
            </Box>
          </Box>
        )}

        <Box>
          <Box className={classes.claimsCardToolbar}>
            <Box className={classes.filterSegs}>
              {["All", "Eligible", "Verification", "Error"].map((seg) => (
                <Box
                  key={seg}
                  component="button"
                  className={`${classes.filterSeg}${clientFilter === seg ? ` ${classes.filterSegActive}` : ""}`}
                  onClick={() => setClientFilter(seg)}
                >
                  {seg === "Verification" ? "Verification Needed" : seg}
                </Box>
              ))}
            </Box>
            <Box className={classes.clientSearchWrap}>
              <TextInput
                placeholder="Search clients…"
                value={clientSearch}
                onChange={(e) => setClientSearch(e.currentTarget.value)}
                icon={<IconSearch size={16} color="var(--app-text-muted)" />}
                className={classes.clientSearchInput}
              />
            </Box>
          </Box>

          <Box className={classes.tableScroll}>
            <table className={classes.dataTable}>
              <thead>
                <tr>
                  <th>Client</th>
                  <th>Member ID</th>
                  <th>Primary payer</th>
                  <th>Plan</th>
                  <th>Authorization #</th>
                  <th>Eligibility</th>
                  <th>Last verified</th>
                  <th>Open claims</th>
                  <th className={classes.tableThRight}></th>
                </tr>
              </thead>
              <tbody>
                {patientLoading ? (
                  Array.from({ length: 6 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Box style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <Skeleton circle height={36} width={36} />
                          <Box>
                            <Skeleton height={10} width={120} mb={6} radius="xl" />
                            <Skeleton height={8} width={90} radius="xl" />
                          </Box>
                        </Box>
                      </td>
                      <td><Skeleton height={10} width={70} radius="xl" /></td>
                      <td><Skeleton height={10} width={80} radius="xl" /></td>
                      <td><Skeleton height={10} width={60} radius="xl" /></td>
                      <td><Skeleton height={10} width={90} radius="xl" /></td>
                      <td><Skeleton height={22} width={80} radius="md" /></td>
                      <td><Skeleton height={10} width={70} radius="xl" /></td>
                      <td><Skeleton height={10} width={30} radius="xl" /></td>
                      <td><Skeleton height={10} width={20} radius="xl" /></td>
                    </tr>
                  ))
                ) : filtered.length > 0 ? (
                  filtered.map((patient, index) => {
                    console.log("🚀 ~ renderClient ~ patient:", patient)
                    const endDate =
                      patient?.form2?.BillingInsurance?.[0]
                        ?.authorizationEndDate;
                    const isExpired = endDate
                      ? moment
                          .tz(endDate, userTimezone)
                          .isBefore(moment.tz(new Date(), userTimezone), "day")
                      : false;
                    const authId =
                      patient?.form2?.BillingInsurance?.[0]?.authorization ||
                      "-";
                    const memberId =
                      patient?.form2?.BillingInsurance?.[0]?.identificationNumber || "-";
                    const payerName =
                      patient?.form2?.BillingInsurance?.[0]?.payer?.name || "-";
                    const plan =
                      patient?.form2?.BillingInsurance?.[0]?.planType || "-";
                    const dob = patient.form1?.dob
                      ? new Date(patient.form1.dob).toLocaleDateString("en-US")
                      : "-";
                    const gender = patient.form1?.gender || "-";
                    const lastVerified = patient?.form2?.BillingInsurance?.[0]
                      ?.lastVerified
                      ? moment(
                          patient.form2.BillingInsurance[0].lastVerified,
                        ).format("MMM D, YYYY · HH:mm")
                      : "-";

                    const decryptedImg = patient?.imageurl
                      ? decrypt(patient.imageurl)
                      : null;

                    return (
                      <tr
                        key={index}
                        onClick={() => handleEditClient(patient, true)}
                      >
                        <td>
                          <Box className={classes.clientCell}>
                            <Box
                              className={classes.clientAvatar}
                              style={
                                decryptedImg
                                  ? {
                                      backgroundImage: `url(${decryptedImg})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      fontSize: 0,
                                      color: "transparent",
                                    }
                                  : {}
                              }
                            >
                              {!decryptedImg && getInitials(patient?.name)}
                            </Box>
                            <Box>
                              <p className={classes.clientName}>
                                {patient?.name || "-"}
                              </p>
                              <p className={classes.clientSub}>
                                DOB {dob} · {gender}
                              </p>
                            </Box>
                          </Box>
                        </td>
                        <td>{memberId}</td>
                        <td>{payerName}</td>
                        <td>{plan}</td>
                        <td>
                          <span className={classes.authCodeCell}>
                            {authId}
                            {isExpired && (
                              <Tooltip
                                label="Authorization expired. Click to update."
                                withArrow
                                position="top"
                              >
                                <Box
                                  component="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditClient(patient, false);
                                  }}
                                  className={classes.authExpiredIcon}
                                >
                                  !
                                </Box>
                              </Tooltip>
                            )}
                          </span>
                        </td>
                        <td>{getEligibilityPill(patient)}</td>
                        <td>{lastVerified}</td>
                        <td>
                          {openClaimsMap[
                            `${patient?.name || ""}`.toLowerCase()
                          ] || 0}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <Box className={classes.actionsCell}>
                            <Menu shadow="md" width={220} withinPortal position="bottom-end">
                              <Menu.Target>
                                <Box
                                  component="button"
                                  className={classes.rowMenuBtn}
                                  title="More"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <LuMoreVertical size={16} />
                                </Box>
                              </Menu.Target>
                              <Menu.Dropdown onClick={(e) => e.stopPropagation()}>
                                {prefs.eligibilityCheck && (
                                  <Menu.Item
                                    icon={<LuShieldCheck size={14} />}
                                    onClick={() => {
                                      setEligibilityPatient(patient);
                                      setEligibilityModalOpen(true);
                                    }}
                                  >
                                    Run Eligibility Check
                                  </Menu.Item>
                                )}
                                <Menu.Item
                                  icon={<LuUserCog size={14} />}
                                  onClick={() => handleEditClient(patient, false)}
                                >
                                  Edit Client
                                </Menu.Item>
                              </Menu.Dropdown>
                            </Menu>
                          </Box>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={9} className={classes.tableEmptyCell}>
                      No clients found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Box>

          {!clientSearch && clientFilter === "All" && (
            <Center mt={12} mb={12}>
              <CustomBillingPagination
                data={patients?.count}
                itemsPerPage={10}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            </Center>
          )}
        </Box>
      </Box>
    );
  };

  const handleDownloadReceipt = async (rc) => {
    const claimId = rc.desc?.match(/CLM-\d+/)?.[0] || "—";
    const payer = rc.desc?.split("paid by ")?.[1] || "—";

    const div = document.createElement("div");
    div.style.cssText =
      "position:fixed;top:-9999px;left:-9999px;width:600px;background:var(--app-surface);padding:24px;font-family:Inter,sans-serif;";
    div.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 18px;background:var(--app-surface-2);border:1px solid var(--app-border);border-radius:10px;margin-bottom:18px;">
        <div>
          <div style="font-size:16px;font-weight:800;color:var(--app-text);">Ogiso, Inc.</div>
          <div style="font-size:12px;font-weight:600;color:var(--app-text);">Billing &amp; Claims Operations</div>
          <div style="font-size:11.5px;color:var(--app-text-muted);margin-top:4px;">support@ogiso.io · 757-600-0297</div>
        </div>
        <div style="font-size:14px;font-weight:800;letter-spacing:0.16em;color:#047857;background:#DCFCE7;border:2px solid #86E1B0;border-radius:8px;padding:8px 16px;transform:rotate(-6deg);">PAID</div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
        <div style="background:var(--app-surface);border:1px solid var(--app-border);border-radius:8px;padding:10px 12px;">
          <div style="font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;">Receipt number</div>
          <div style="font-size:13px;font-weight:700;color:var(--app-text);">${rc.num}</div>
        </div>
        <div style="background:var(--app-surface);border:1px solid var(--app-border);border-radius:8px;padding:10px 12px;">
          <div style="font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;">Issued date</div>
          <div style="font-size:13px;font-weight:700;color:var(--app-text);">${rc.date}</div>
        </div>
        <div style="background:var(--app-surface);border:1px solid var(--app-border);border-radius:8px;padding:10px 12px;">
          <div style="font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;">Related claim</div>
          <div style="font-size:13px;font-weight:700;color:var(--app-text);">${claimId}</div>
        </div>
        <div style="background:var(--app-surface);border:1px solid var(--app-border);border-radius:8px;padding:10px 12px;">
          <div style="font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;">Payer</div>
          <div style="font-size:13px;font-weight:700;color:var(--app-text);">${payer}</div>
        </div>
      </div>
      <h6 style="margin:20px 0 8px;font-size:11.5px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;">Line items</h6>
      <table style="width:100%;border-collapse:collapse;border:1px solid var(--app-border);font-size:13px;">
        <thead>
          <tr>
            <th style="background:var(--app-surface-2);font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;padding:10px 12px;text-align:left;border-bottom:1px solid var(--app-border);">Description</th>
            <th style="background:var(--app-surface-2);font-size:11px;font-weight:700;color:var(--app-text-muted);text-transform:uppercase;letter-spacing:0.05em;padding:10px 12px;text-align:right;border-bottom:1px solid var(--app-border);">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding:12px;color:var(--app-text);">${rc.desc}</td>
            <td style="padding:12px;color:var(--app-text);text-align:right;">${rc.amount}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td style="padding:12px;background:var(--app-surface-2);border-top:1px solid var(--app-border);font-weight:800;color:var(--app-text);">Total deducted from remittance</td>
            <td style="padding:12px;background:var(--app-surface-2);border-top:1px solid var(--app-border);font-weight:800;color:var(--app-text);text-align:right;">${rc.amount}</td>
          </tr>
        </tfoot>
      </table>
      <p style="margin:16px 0 0;font-size:12px;color:var(--app-text-muted);line-height:1.55;">Processing fees are deducted automatically from each remittance. This record is retained for your books and is downloadable as a PDF for accounting reconciliation.</p>
    `;
    document.body.appendChild(div);
    try {
      const canvas = await html2canvas(div, { scale: 2, useCORS: true, backgroundColor: "var(--app-surface)", logging: false });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Receipt-${rc.num}.pdf`);
    } finally {
      document.body.removeChild(div);
    }
  };

  const handleReceiptsPageChange = async (page) => {
    setReceiptsPage(page);
    await getAllBillingPayments({ page });
  };

  const renderReceipts = () => {
    const payments = allbillingPayments?.BillingPayment ?? [];

    const receipts = payments.map((data) => {
      const matchingClaim = data?.billingId?.billingForm?.claim?.find(
        (c) => String(c.stedi_claim_id || c.claimmd_id) === String(data?.claimId)
      );
      const payerName = matchingClaim?.payer_name || "N/A";
      const date = data?.updatedAt
        ? new Date(data.updatedAt).toLocaleDateString("en-US", {
            month: "short", day: "numeric", year: "numeric",
          })
        : "—";
      return {
        id: data?._id || data?.id,
        num: data?.claimId || "—",
        date,
        desc: `Processing fee · ${data?.claimId || "—"} paid by ${payerName}`,
        amount: data?.transactionFee != null
          ? `$${data.transactionFee.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : "—",
      };
    });

    return (
      <Box className={classes.panelCardNoPad}>
        <Box className={classes.panelCardHeaderInner}>
          <h3 className={classes.panelCardTitle}>Receipts</h3>
          <p className={classes.panelCardDesc}>
            Processing-fee receipts and remittance records. Download a copy for
            your books anytime.
          </p>
        </Box>
        <table className={classes.linesTable}>
          <thead>
            <tr>
              <th className={classes.tableThPadL}>Date</th>
              <th>Receipt #</th>
              <th>Description</th>
              <th>Amount</th>
              <th className={classes.tableThPadR}></th>
            </tr>
          </thead>
          <tbody>
            {receipts.length === 0 ? (
              <tr>
                <td colSpan={5} className={classes.tableEmptyCell}>
                  No receipts found.
                </td>
              </tr>
            ) : (
              receipts.map((rc) => (
                <tr key={rc.id}>
                  <td className={classes.tableTdPadL}>{rc.date}</td>
                  <td><b>{rc.num}</b></td>
                  <td>{rc.desc}</td>
                  <td>{rc.amount}</td>
                  <td className={classes.tableTdPadR}>
                    <Box className={classes.actionsCellEnd}>
                      <Box
                        component="button"
                        className={classes.rcActionBtn}
                        title="View receipt"
                        onClick={() => setReceiptModal({ opened: true, receipt: rc })}
                      >
                        <LuEye size={16} />
                      </Box>
                      <Box
                        component="button"
                        className={classes.rcActionBtn}
                        title="Download receipt"
                        onClick={() => handleDownloadReceipt(rc)}
                      >
                        <LuDownload size={16} />
                      </Box>
                    </Box>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {allbillingPayments?.count > 10 && (
          <Box sx={{ display: "flex", justifyContent: "center", padding: "16px 20px" }}>
            <CustomBillingPagination
              data={allbillingPayments?.count}
              itemsPerPage={10}
              currentPage={receiptsPage}
              handlePageChange={handleReceiptsPageChange}
            />
          </Box>
        )}
      </Box>
    );
  };

  const renderPayment = () => (
    <Box className={classes.panelCard}>
      <Box className={classes.panelCardHeader}>
        <h3 className={classes.panelCardTitle}>Payments</h3>
        <p className={classes.panelCardDesc}>
          Manage your payment methods and billing history.
        </p>
      </Box>
      <PaymentTab
        paymentype={paymentype}
        setPaymentType={setPaymentType}
        setState={() => {}}
        state={{}}
        manage={true}
        setAchServices={setAchServices}
        achservices={achservices}
      />
    </Box>
  );

  const renderPanel = () => {
    switch (activeTab) {
      case "preferences":
        return renderPreferences();
      case "provider":
        return renderProvider();
      case "payer":
        return renderPayer();
      case "client":
        return renderClient();
      case "receipts":
        return renderReceipts();
      // case "payment":
      //   return renderPayment();
      default:
        return renderPreferences();
    }
  };

  return (
    <Box fluid className="content">
      <AppNavbar title="Billing Settings" profile={profile} />
      <Box className={classes.pageWrapper}>
        <ClaimToolbar />

        <Button
          variant="unstyled"
          leftIcon={<LuArrowLeft />}
          className={classes.backBtn}
          onClick={() => navigate("/home/billing")}
        >
          Back to All Claims
        </Button>

        <Box className={classes.settingsGrid}>
          {/* Sidebar */}
          <Box className={classes.settingsSide}>
            {SIDEBAR_ITEMS.map((group) => (
              <Box key={group.section} className={classes.sideSection}>
                <p className={classes.sideSectionLabel}>{group.section}</p>
                {group.items.map(({ key, label, icon: Icon }) => (
                  <Box
                    key={key}
                    component="button"
                    className={`${classes.sideItem}${activeTab === key ? ` ${classes.sideItemActive}` : ""}`}
                    onClick={() => setActiveTab(key)}
                  >
                    <Icon className={classes.sideItemIcon} />
                    {label}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>

          {/* Content Panel */}
          <Box className={classes.settingsPanel}>{renderPanel()}</Box>
        </Box>

        {/* Modals */}
        <AddProvider state={state} setState={setState} onSaved={() => setCurrentPage(1)} />

        <EditProvider
          editprovider={editprovider}
          setEditProvider={setEditProvider}
          item={provideritem}
          isPreview={view}
          onSaved={() => setCurrentPage(1)}
        />

        <ProviderEnrollment
          EditProviderEnrollmentModalOpen={providerEnrollment}
          setEditProviderEnrollmentrModalOpen={setProviderEnrollment}
          item={provideritem}
        />

        <AddPayer
          state={state}
          setState={setState}
          payerclient={allpayer?.payer || []}
          onSaved={() => setCurrentPage(1)}
        />

        <EditPayer
          EditPayerModalOpen={EditPayerModalOpen}
          setEditPayerModalOpen={setEditPayerModalOpen}
          item={editPayerItem}
          isPreview={view}
          onSaved={() => setCurrentPage(1)}
        />

        <AddClient
          state={state}
          setState={setState}
          payerclient={allpayer?.payer || []}
          onSaved={() => setCurrentPage(1)}
        />

        <EditClient
          editclient={editclient}
          setEditclient={setEditclient}
          patient={editClientItem}
          isPreview={view}
          onSaved={() => setCurrentPage(1)}
        />

        <VerifyEligibilityModal
          opened={eligibilityModalOpen}
          patient={eligibilityPatient}
          onClose={() => {
            setEligibilityModalOpen(false);
            setEligibilityPatient(null);
          }}
          onVerified={(pat, ts) => {
            handleEligibilityVerified(pat, ts);
          }}
        />

        <ReceiptViewModal
          opened={receiptModal.opened}
          onClose={() => setReceiptModal({ opened: false, receipt: null })}
          receipt={receiptModal.receipt}
        />
      </Box>
    </Box>
  );
};

export default BillingSettings;
